import { apiService } from './api.service';
import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { SolarModule, SolarModuleQuery } from '../types';

class SolarModulesService {
  async getAllModules(query?: SolarModuleQuery & { status?: string }): Promise<SolarModule[]> {
    const params: Record<string, string> = {
      [QUERY_PARAMS.STATUS]: query?.status || STATUS_FILTER_VALUES.ALL
    };
    
    if (query?.brandId) {
      params[QUERY_PARAMS.BRAND_ID] = query.brandId;
    }

    return apiService.get<SolarModule[]>(CR_API_ENDPOINTS.SOLAR_MODULES, params);
  }

  async getModulesByBrand(brandId: string): Promise<SolarModule[]> {
    return this.getAllModules({ brandId });
  }

  async createModule(moduleData: {
    fullName: string;
    modelNumber: string;
    wattage: number;
    width?: number;
    height?: number;
    brandId: string;
  }): Promise<SolarModule> {
    return apiService.post<SolarModule>(CR_API_ENDPOINTS.SOLAR_MODULES, moduleData);
  }
}

export const solarModulesService = new SolarModulesService();